// ********Save/Update button function API */
export const SaveInvoiceDetails = async (VenderDesignation) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(VenderDesignation)
        }

        const response = await fetch(`${ApiURL}Invoice`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200" && responseData.success) {
            return { success: true, data: responseData.data };
        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("SaveInvoiceDetails error:", error);
        return { success: false, data: "An error occurred." };
    }
};
// ********End of Save/Update button function API */


// ********Delete button function API */
export const DeleteInvoiceDetails = async (rowDelete) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(rowDelete)
        };

        const response = await fetch(`${ApiURL}Common/Delete`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.data == "Cannot Delete, Record Already Used!") {
                return { success: false, data: responseData.data };

            } else {
                return { success: true, data: responseData.data }
            }
        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("DeleteInvoiceDetails error:", error);
    }
};

// ********End of Delete button function API */


// *** Get and Set values when user search code function API*/
export const InvoiceDetailsGetData = async (searchData, location) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            }
        };
        const response = await fetch(`${ApiURL}Invoice/Invs/${searchData}/${location}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200" && responseData.success) {
            return { success: true, data: responseData.data, message: responseData.msg };
        } else {
            return { success: false, data: {}, message: responseData.msg };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {}, message: "An error occurred." };
    }
}

// *** End of Get and Set values when user search code function API*/